module.exports = __webpack_public_path__ + "static/media/img34.3984b50d.jpg";